// import React from 'react';

import React, { useState } from 'react'
import { Button, Typography, Divider, Box, Stack, useTheme } from '@mui/material';
import ScrollBox from '../../../components/ScrollBox';
import BackButton from '../../../components/BackButton';
import ProductReqCard from '../../../components/ProductReqCard';
import LabelTxtFieldInfo from '../../../components/LabelTxtFieldInfo';
import { replace, useLocation, useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../../context/AuthContext';
import BgBoxOld from '../../../components/BgBoxOld';
import { Add } from '@mui/icons-material';
import { useQuery, useQueryClient } from 'react-query';
import QueryKey from '../../../utils/QueryKey';
import { editProdReqServ, getSingleProdReqServ } from '../../../services/prodreq-service';
import { useEffect } from 'react';
import { customAlert, notify } from '../../../components/notify';
import route from '../../../utils/Routes';
import { isNotEmpty } from '../../../utils/format';
import NotesMdl from '../../../components/NotesMdl';
import AddComProdMdl from './AddComProdMdl';

function EditProdReqPage() {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const { prodReqId } = location.state || {};
  const { setLoadingScreen } = useAuthContext();
  const [formErrors, setFormErrors] = useState({});
  const queryClient = useQueryClient();
  const { isLoading, isError, error, data: reqData } = useQuery([QueryKey.prodReqInfo, prodReqId], () => getSingleProdReqServ(prodReqId), {
    enabled: isNotEmpty(prodReqId),
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    keepPreviousData: true
  });

  const [selProds, setSelProds] = useState([]);
  const [payload, setPayload] = useState(null)
  const [notesMdl, setNotesMdl] = useState(false);
  const handleNotesMdlClose = () => setNotesMdl(false);
  const [addProdMdl, setAddProdMdl] = useState(false);
  const handleAddProdMdlopen = () => setAddProdMdl(true);
  const handleAddProdMdlClose = () => setAddProdMdl(false);

  useEffect(() => {
    if (!prodReqId)
      navigate("/", { replace: true })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prodReqId])


  useEffect(() => {
    setLoadingScreen(isLoading);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);


  useEffect(() => {
    if (!reqData)
      return
    if (!reqData?.prods)
      return;

    setSelProds(reqData?.prods)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reqData]);


  async function handleMdlSave({ editRemarks }) {
    setNotesMdl(false)
    setLoadingScreen(true);
    try {
      const reqBody = {
        editRemarks, ...payload
      }
      const { message } = await editProdReqServ(reqBody, prodReqId);
      queryClient.invalidateQueries();
      notify("success", message);
      navigate(`${route.cProdreqinfo}/?prodReqId=${prodReqId}`, { replace: true })
    } catch (error) {
      console.log(error)
      customAlert(error)
    }
    setLoadingScreen(false);
  }

  function handleAddProdCardClick(prodData) {
    setSelProds((prev) => {
      const existingProdIndex = prev.findIndex((i) => i.amtcProdIdStrg === prodData.amtcProdIdStrg);
      if (existingProdIndex === -1) {
        // If product doesn't exist, add it with quantity 1
        return [...prev, { ...prodData, qty: 1 }];
      } else {
        // If product exists, update its quantity
        return prev.map((prod, index) =>
          index === existingProdIndex ? { ...prod, qty: prod.qty + 1 } : prod
        );
      }
    });
    handleAddProdMdlClose();
  }


  async function handleQuantityChange(prodIndex, qty) {
    const updatedProducts = [...selProds];
    updatedProducts[prodIndex]['qty'] += qty;
    if (updatedProducts[prodIndex]['qty'] === 0) {
      updatedProducts.splice(prodIndex, 1);
    }
    setSelProds(updatedProducts);

  };

  async function handleProdRemove(prodIndex) {
    const updatedProducts = [...selProds];
    updatedProducts.splice(prodIndex, 1);
    setSelProds(updatedProducts);

  };


  async function handleSubmit(e) {
    e.preventDefault();
    if (selProds.length === 0) {
      notify("error", "Kindly select at least one product!")
      return;
    }
    const formData = new FormData(e.target);
    const inputObject = Object.fromEntries(formData); // convert the FormData object to a JSON object
    let errorsObj = validate(inputObject);
    setFormErrors(errorsObj);
    if (Object.keys(errorsObj).length > 0)
      return;

    const payload = {
      description: inputObject.description,
      prodsArr: selProds.map((i) => ({ amtcProdIdStrg: i?.amtcProdIdStrg, qty: i?.qty }))
    }
    setPayload(payload);
    setNotesMdl(true);
  };

  function validate(values) {
    const errors = {};

    // if (!values.projName)
    //     errors.projName = "Project Name is required!";

    return errors;
  };



  async function handleCancel() {
    navigate(`${route.cProdreqinfo}/?prodReqId=${prodReqId}`, { replace: true })
  }



  if (isError) {
    customAlert(error);
    return <h2>Something went wrong</h2>
  }

  return (<>
    {reqData && <form onSubmit={handleSubmit} noValidate id='addPo' style={{ padding: 0, height: "100%", width: "100%", position: "relative" }}>
      <Stack direction={"row"} alignItems={'center'} justifyContent={'space-between'} mb={1} mt={0.5}>
        <BackButton />
        <Typography sx={{ fontSize: 18, fontWeight: 500 }}>Edit Product Request ({prodReqId})</Typography>
        <Box />
      </Stack>
      <BgBoxOld height={"93%"} py={1}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
          <Typography sx={{ fontSize: 16, fontWeight: 600 }}>Products</Typography>
          <Button onClick={handleAddProdMdlopen} startIcon={<Add />}
            sx={{ bgcolor: 'white', color: 'rgba(0, 16, 238, 1)', borderRadius: 1.5, boxShadow: 3, width: 150 }}>Add Product</Button>
        </Box>
        <Divider sx={{ mt: 0.5 }} />

        <ScrollBox height={"50%"}>
          {(selProds || []).map((i, index) => (
            <React.Fragment key={i?.id}>
              <ProductReqCard i={i} onQuantityChange={handleQuantityChange} onRemove={handleProdRemove} index={index} />
              {index < selProds.length - 1 && <Divider sx={{ py: 0.2 }} />}
            </React.Fragment>
          ))}
        </ScrollBox>
        <LabelTxtFieldInfo defaultValue={reqData?.description} name="description" title="Remarks" width={"100%"} height={100} borderRadius={1} rows={4} multiline={true} />
      </BgBoxOld>


      <Box sx={{ position: "absolute", bottom: 20, right: 20 }}>
        <Button variant="outlined" onClick={handleCancel} sx={{
          fontWeight: 600, height: 40, width: 100, borderRadius: 2, backgroundColor: theme.palette.custom.grey,
          color: theme.palette.custom.btn, mr: 2,
        }}>CANCEL</Button>
        <Button variant="contained" type="submit"
          sx={{ fontWeight: 600, height: 40, width: 100, bgcolor: theme.palette.custom.btn, color: "white", }}>SAVE</Button>
      </Box>
      {payload && <NotesMdl modalOpen={notesMdl} handleModalClose={handleNotesMdlClose} handleMdlSave={handleMdlSave} payload={payload} />}
      <AddComProdMdl modalOpen={addProdMdl} handleModalClose={handleAddProdMdlClose} handleAddProdCardClick={handleAddProdCardClick} />
    </form>}
  </>);
}

export default EditProdReqPage;